import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

import { Box, MenuItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const AgentAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
  allCountry,
  allMethod,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [sourceCurrency, setSourceCurrency] = useState('');
  const [destinationCurrency, setDestinationCurrency] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentOption, setPaymentOption] = useState('');
  const [paymentOptionAll, setPaymentOptionAll] = useState([]);
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [deliveryOption, setDeliveryOption] = useState('');
  const [deliveryOptionAll, setDeliveryOptionAll] = useState([]);
  const [fromAmount, setFromAmount] = useState(1);
  const [toAmount, setToAmount] = useState('');
  const [charge, setCharge] = useState('');
  const [status, setStatus] = useState('');

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearStates = () => {
    // setId('');
    // setName('');
    setStatus(false);
    setEditObj({});
  };

  const handleSubmit = async e => {
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let formData = {
      sourceCurrency,
      destinationCurrency,
      paymentMethod,
      paymentOption,
      deliveryMethod,
      deliveryOption,
      fromAmount,
      toAmount,
      charge,
      status,
    };
    // return console.log('data', formData);
    try {
      if (addForm) {
        response = await axios({
          url: `/api/v1/private/transaction/transaction-charge`,
          method: 'post',
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setList([...list, response.data.data]);
        clearStates();
      } else if (editForm) {
        response = await axios({
          url: `/api/v1/private/transaction/transaction-charge/${id}`,
          method: 'put',
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log('editForm response', response);

        list[editIndexNo] = response.data.data;
        setRefresh(!refresh);
      }

      closeAddDialog();
      activeAddForm();
      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  const handlePaymentMethod = value => {
    setPaymentMethod(value);
    let pay = allMethod.filter(item => item.code === value);
    if (pay.length > 0) {
      setPaymentOptionAll(pay[0].options);
    } else {
      setPaymentOptionAll(allMethod[0].options);
    }
  };

  const handleDeliveryMethod = value => {
    setDeliveryMethod(value);
    let pay = allMethod.filter(item => item.code === value);
    if (pay.length > 0) {
      setDeliveryOptionAll(pay[0].options);
    } else {
      setDeliveryOptionAll(allMethod[0].options);
    }
  };

  useEffect(() => {
    if (editObj.id) {
      handlePaymentMethod(editObj.paymentMethod);
      handleDeliveryMethod(editObj.deliveryMethod);

      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);

      setTimeout(() => {
        setSourceCurrency(editObj.sourceCurrency);
        setDestinationCurrency(editObj.destinationCurrency);
        setPaymentMethod(editObj.paymentMethod);

        setPaymentOption(editObj.paymentOption);
        setDeliveryMethod(editObj.deliveryMethod);
        setDeliveryOption(editObj.deliveryOption);
        setFromAmount(editObj.fromAmount);
        setToAmount(editObj.toAmount);
        setCharge(editObj.charge);
        setStatus(editObj.status);
      }, 100);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };
  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);

  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update Bank' : 'Add Bank'}
        </Typography>
      </div> */}
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update transaction charge policy' : 'Add transaction charge policy'}
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
        <TextField
          variant="outlined"
          select
          label="Source Currency"
          size="small"
          fullWidth
          required
          value={sourceCurrency}
          onChange={e => setSourceCurrency(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((item, index) => (
            <MenuItem value={item.currency} key={index}>
              <Box className={classes.inner}>
                <img src={item.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {item.currency}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Destination Currency"
          size="small"
          fullWidth
          required
          value={destinationCurrency}
          onChange={e => setDestinationCurrency(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((item, index) => (
            <MenuItem value={item.currency} key={index}>
              <Box className={classes.inner}>
                <img src={item.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {item.currency}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Payment Method"
          size="small"
          fullWidth
          required
          value={paymentMethod}
          onChange={e => {
            handlePaymentMethod(e.target.value);
          }}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allMethod.map((item, index) => (
            <MenuItem key={index} value={item.code}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Payment Option"
          size="small"
          fullWidth
          value={paymentOption}
          onChange={e => {
            setPaymentOption(e.target.value);
          }}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {paymentOptionAll &&
            paymentOptionAll.map((item, index) => (
              <MenuItem value={item.code} key={index}>
                {item.name}
              </MenuItem>
            ))}
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Delivery Method"
          size="small"
          fullWidth
          required
          value={deliveryMethod}
          onChange={e => {
            handleDeliveryMethod(e.target.value);
          }}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allMethod.map((item, index) => (
            <MenuItem key={index} value={item.code}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Delivery Option"
          size="small"
          fullWidth
          value={deliveryOption}
          onChange={e => {
            setDeliveryOption(e.target.value);
          }}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {deliveryOptionAll.map((item, index) => (
            <MenuItem value={item.code} key={index}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="From Amount"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={fromAmount}
          onChange={e => setFromAmount(e.target.value)}
        />
        <TextField
          label="To Amount"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={toAmount}
          onChange={e => setToAmount(e.target.value)}
        />
        <TextField
          label="Charge"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={charge}
          onChange={e => setCharge(e.target.value)}
        />

        <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
          <FormControlLabel
            control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
            label="Status"
            labelPlacement="start"
          />
        </div>

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            {editForm ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default AgentAddEdit;
